'use strict';

const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid');
const reject = require('lodash/reject');
const filter = require('lodash/filter');

const ChannelActions = require('../actions/ChannelActions');
const ProjectActions = require('../actions/ProjectActions');
const OrganizationActions = require('../actions/OrganizationActions');
const AccountActions = require('../actions/AccountActions');
const SignInStore = require('./SignInStore');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const SignInActions = require('../actions/sign_in_actions');

const Globals = require('../../../app/globals');

let channels = [];
let folders = {}; // a nested object representing the folder structure
let foldersFlat = {}; // an single level object containing all known folders
let shortCourseFolders = {};
let shortCourseFoldersFlat = {};
let channelChatbotUsage = {};
let initialized = false;
let action = {};
let error = null;

function getObjForContentType(contentType) {
    if (contentType === Globals.content_type.ACTIVITY) {
        return folders;
    }
    else if (contentType === Globals.content_type.COURSE) {
        return shortCourseFolders;
    }
    else {
        console.error(`FolderStore.getObjForContentType: Unknown content type "${contentType}"`);
        return null;
    }
}

function getFlatObjForContentType(contentType) {
    if (contentType === Globals.content_type.ACTIVITY) {
        return foldersFlat;
    }
    else if (contentType === Globals.content_type.COURSE) {
        return shortCourseFoldersFlat;
    }
    else {
        console.error(`FolderStore.getFlatObjForContentType: Unknown content type "${contentType}"`);
        return null;
    }
}

const ChannelStore = Reflux.createStore({
    listenables: [ChannelActions, SignInActions, OrganizationActions, ProjectActions, AccountActions],
    init: function() {
        if(SignInStore.getState().initializedLocal){
            this.getAllChannels();
        }

        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        channels = [];
        folders = {};
        foldersFlat = {};
        shortCourseFolders = {};
        shortCourseFoldersFlat = {};
        channelChatbotUsage = {};
        initialized = false;
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState){
        if (signInStoreState.initializedLocal) {
            ChannelActions.getAllChannels(uuid.v4());
        }
    },

    getChannels: function() {
        return reject(channels, (channel) => {
            return [Globals.users.account_types.SCHOOL, Globals.users.account_types.ENTERPRISE].indexOf(channel.channel_account_type_token) >= 0;
        });
    },

    onGetAllProjectsCompleted: function(actionId, res) {
        this.addFolderArray(res.folders);
        this.emitStatus();
    },

    getOrganizations: function() {
        return filter(channels, (channel) => {
            return [Globals.users.account_types.SCHOOL, Globals.users.account_types.ENTERPRISE].indexOf(channel.channel_account_type_token) >= 0;
        });
    },

    getChannelsAndOrgs: function() {
        return channels;
    },

    getState: function() {
        return {
            initialized: initialized,
            channels: this.getChannels(),
            folders: folders,
            foldersFlat: foldersFlat,
            shortCourseFolders: shortCourseFolders,
            shortCourseFoldersFlat: shortCourseFoldersFlat,
            organizations: this.getOrganizations(),
            channelsAndOrgs: this.getChannelsAndOrgs(),
            action: action,
            error: error
        }
    },

    getStateChannel: function(channelId) {
        return {
            initialized: initialized,
            channel: this.getChannelsAndOrgs().find(c => c.id === parseInt(channelId, 10)),
            folders: folders[channelId] || {},
            foldersFlat: foldersFlat[channelId] || {},
            shortCourseFolders: shortCourseFolders[channelId] || {},
            shortCourseFoldersFlat: shortCourseFoldersFlat[channelId] || {},
            chatbotUsage: channelChatbotUsage[channelId],
            action: action,
            error: error
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null; //do not reset channel error
    },

    // merge folder array into existing store 'folders' object
    addFolderArray(folderArr) {
        // add root folders
        let descendantFolders = []; // 2nd & 3rd gen folders (assume only 3 gens)
        folderArr.forEach((folder) => {
            let folderObj = getObjForContentType(folder.content_type);
            let folderFlatObj = getFlatObjForContentType(folder.content_type);

            if (!folder.parent_id) {
                if (!folderObj[folder.user_id]) folderObj[folder.user_id] = {};

                folderObj[folder.user_id][folder.id] = {
                    ...folderObj[folder.user_id][folder.id],
                    ...folder
                }; // merge
                if (!folderObj[folder.user_id][folder.id].children) {
                    folderObj[folder.user_id][folder.id].children = {};
                }
            }
            else {
                descendantFolders.push(folder);
            }

            if (!folderFlatObj[folder.user_id]) folderFlatObj[folder.user_id] = {};
            folderFlatObj[folder.user_id][folder.id] = folder;
        });

        // add second gen folders
        let thirdGenFolders = [];
        descendantFolders.forEach((folder) => {
            let folderObj = getObjForContentType(folder.content_type);
            if (!folder.gp_id) {
                if (
                    !folderObj[folder.user_id]
                    || !folderObj[folder.user_id][folder.parent_id]
                ) {
                    console.error(`ChannelStore.addFolderArray - Cannot find root folder for second gen folder`, folder);
                }
                else {
                    folderObj[folder.user_id][folder.parent_id].children[folder.id] = {
                        ...folderObj[folder.user_id][folder.parent_id].children[folder.id],
                        ...folder
                    };
                    if (!folderObj[folder.user_id][folder.parent_id].children[folder.id].children) {
                        folderObj[folder.user_id][folder.parent_id].children[folder.id].children = {};
                    }
                    // no futher children
                }
            }
            else {
                thirdGenFolders.push(folder);
            }
        });

        // add third gen folders
        thirdGenFolders.forEach((folder) => {
            let folderObj = getObjForContentType(folder.content_type);
            if (
                !folderObj[folder.user_id]
                || !folderObj[folder.user_id][folder.gp_id]
                || !folderObj[folder.user_id][folder.gp_id].children[folder.parent_id]
            ) {
                console.error(`ChannelStore.addFolderArray - Cannot find root folder for third gen folder`, folder);
            }
            else {
                folderObj[folder.user_id][folder.gp_id].children[folder.parent_id].children[folder.id] = {
                    ...folderObj[folder.user_id][folder.gp_id].children[folder.parent_id].children[folder.id],
                    ...folder
                };
            }
        });
    },

    onGetAllChannelsCompleted: function(actionId, res) {
        action = { id: actionId };
        initialized = true;
        channels = res.channels;
        this.addFolderArray(res.folders);
        this.emitStatus();
    },

    onGetAllChannelsFailed: function(actionId, err) {
        let error;

        switch (err.status) {
            case 403:
                error = new ForgeError({ message: ErrorConsts.FETCH_FAILED_CHANNELS + ": " + ErrorConsts.FORBIDDEN });
                break;
            default:
                error = new ForgeError({ message: ErrorConsts.FETCH_FAILED_CHANNELS + ": " + ErrorConsts.INTERNAL_GENERAL });
        }

        action = { id: actionId, error: error };
        initialized = true;
        this.emitStatus();
    },

    onUpdateOrgInfoCompleted: function(actionId, orgId, orgInfo) {
        ChannelActions.getAllChannels(uuid.v4());
    },

    _mergeNewChannelUserSettings: function(actionId, channelId, res) {
        channels = channels.map((channel) => {
            if (channel.id === channelId) {
                return {
                    ...channel,
                    enable_share_links: res.enable_share_links,
                    enable_student_feedback: res.enable_student_feedback,
                    custom_config: res.custom_config,
                };
            }
            else {
                return channel;
            }
        });

        this.emitStatus();
    },

    onGetUserSettingsCompleted: (actionId, channelId, res) => { ChannelStore._mergeNewChannelUserSettings(actionId, channelId, res); },
    onUpdateUserSettingsCompleted: (actionId, channelId, res) => { ChannelStore._mergeNewChannelUserSettings(actionId, channelId, res); },
    onGetOrgUserSettingsCompleted: (actionId, channelId, res) => { ChannelStore._mergeNewChannelUserSettings(actionId, channelId, res); },
    onUpdateOrgUserSettingsCompleted: (actionId, channelId, res) => { ChannelStore._mergeNewChannelUserSettings(actionId, channelId, res); },

    onGetAllFoldersCompleted: function(actionId, res) {
        action = { id: actionId };
        this.addFolderArray(res);
        this.emitStatus();
    },

    onGetAllFoldersFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onCreateFolderCompleted: function(actionId, res) {
        action = { id: actionId };
        this.addFolderArray([res]);
        this.emitStatus();
    },

    onCreateFolderFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onCreateSubfolderCompleted: function(actionId, res) {
        action = { id: actionId };
        this.addFolderArray([res]);
        this.emitStatus();
    },

    onCreateSubfolderFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteFolderCompleted: function(actionId, rootDeletedFolderId, channelId, res) {
        action = { id: actionId };
        function reconcileDeleted(obj, flatObj) {
            let newFolderArrayForChannel = [];
            let newFoldersFlatForChannel = {};
            let foundDeleted = false;
            if (flatObj[channelId]) {
                Object.keys(flatObj[channelId]).forEach((folderId) => {
                    if (res.deletedFolderIds.indexOf(folderId) >= 0) {
                        foundDeleted = true;
                        return; // deleted folder
                    }

                    newFolderArrayForChannel.push(flatObj[channelId][folderId]);
                    newFoldersFlatForChannel[folderId] = flatObj[channelId][folderId];
                });
            }

            if (foundDeleted) {
                flatObj[channelId] = newFoldersFlatForChannel;
                obj[channelId] = {};
                ChannelStore.addFolderArray(newFolderArrayForChannel);
            }
        }

        reconcileDeleted(folders, foldersFlat);
        reconcileDeleted(shortCourseFolders, shortCourseFoldersFlat);

        this.emitStatus();
    },

    onDeleteFolderFailed: function(actionId, rootDeletedFolderId, channelId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    // replace 'folder' if it exists (else add) in both 'folders' & 'foldersFlat'
    _replaceFolder: function(folder) {
        const obj = getObjForContentType(folder.content_type);
        const flatObj = getObjForContentType(folder.content_type);

        let replaced = false;
        let newFolderArrayForChannel = [];
        Object.keys(flatObj[folder.user_id]).forEach((folderId) => {
            if (folderId === folder.id) {
                replaced = true;
                newFolderArrayForChannel.push(folder);
            }
            else {
                newFolderArrayForChannel.push(flatObj[folder.user_id][folderId]);
            }
        });

        if (!replaced) {
            newFolderArrayForChannel.push(folder);
        }

        if (!flatObj[folder.user_id]) flatObj[folder.user_id] = {};
        flatObj[folder.user_id][folder.id] = folder;
        obj[folder.user_id] = {};
        this.addFolderArray(newFolderArrayForChannel);
    },

    onRenameFolderCompleted: function(actionId, res) {
        action = { id: actionId };
        this._replaceFolder(res);
        this.emitStatus();
    },

    onRenameFolderFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onAdminGetChatbotUsageCompleted: function(actionId, channelId, res) {
        action = { id: actionId, type: 'adminGetChannelUsage' };
        channelChatbotUsage[channelId] = res;
        this.emitStatus();
        
    },
    onAdminGetChatbotUsageFailed: function(actionId, channelId, err) {
        console.warn("onAdminGetChatbotUsageFailed: ", actionId,channelId, err);
        this.onError(actionId, err);
    },
    
});

module.exports = ChannelStore;
